// extracted by mini-css-extract-plugin
export default {"btnpwd":"_171c83ac08"};